function _toConsumableArray(r) {
  return (
    _arrayWithoutHoles(r) ||
    _iterableToArray(r) ||
    _unsupportedIterableToArray(r) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}
function _unsupportedIterableToArray(r, e) {
  let t;
  if (r)
    return 'string' === typeof r
      ? _arrayLikeToArray(r, e)
      : 'Map' ===
            (t =
              'Object' === (t = {}.toString.call(r).slice(8, -1)) &&
              r.constructor
                ? r.constructor.name
                : t) || 'Set' === t
        ? Array.from(r)
        : 'Arguments' === t ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
          ? _arrayLikeToArray(r, e)
          : void 0;
}
function _iterableToArray(r) {
  if (
    ('undefined' !== typeof Symbol && null !== r[Symbol.iterator]) ||
    null !== r['@@iterator']
  )
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, e) {
  (null === e || e > r.length) && (e = r.length);
  for (var t = 0, a = Array(e); t < e; t++) a[t] = r[t];
  return a;
}
$(document).ready(() => {
  let r = document.querySelector('#loadmore'),
    a = 6;
  r.addEventListener('click', (r) => {
    for (
      var e = _toConsumableArray(
          document.querySelectorAll('.exhibition-blog__blog-articles .article')
        ),
        t = a;
      t < a + 6;
      t++
    )
      e[t] && e[t].classList.remove('hide');
    (a += 6) >= e.length && (event.target.style.display = 'none');
  });
});
